import { isKYCApp } from 'getaway-data-layer';
import { parse, stringify } from 'query-string';

export const navigateTo = (
  history: any,
  path: string,
  preserveQueryParams: boolean = true
) => {
  if (!path) {
    history.push(isKYCApp() ? '/map' : 'settings');
  }

  let newPath = path;
  if (preserveQueryParams) {
    const currentQueryParams = parse(location.search);
    const updatedQueryString = stringify(currentQueryParams);
    // Append query parameters only if they exist
    if (updatedQueryString) {
      const separator = path.includes('?') ? '&' : '?';
      newPath = `${path}${separator}${updatedQueryString}`;
    }
  }

  if (newPath === '/map' && isKYCApp()) {
    history.push('/');
  } else {
    history.push(newPath);
  }
};

export const openLink = (link) => () => {
  if (link) window.open(link, '_blank');
};
